import { Component } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AcceptanceCriteriaService } from '../../core/services/acceptance-criteria.service';
import { RouterModule, Router } from '@angular/router';
import { AcceptanceCriteriaFormBaseComponent } from '../acceptance-criteria-form-base.component';

@Component({
  selector: 'app-acceptance-criteria-create',
  templateUrl: './acceptance-criteria-create.component.html',
  styleUrls: ['./acceptance-criteria-create.component.scss'],
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterModule],
})
export class AcceptanceCriteriaCreateComponent extends AcceptanceCriteriaFormBaseComponent {
  selectedFile: File | null = null;
  fileBase64: string | null = null;
  originalFileName: string | null = null;
  constructor(
    protected override fb: FormBuilder,
    private criteriaService: AcceptanceCriteriaService,
    private router: Router,
  ) {
    super(fb);
    if (!this.criteriaForm.contains('filePath')) {
      this.criteriaForm.addControl('filePath', this.fb.control(''));
    }
    if (!this.criteriaForm.contains('originalFileName')) {
      this.criteriaForm.addControl('originalFileName', this.fb.control(''));
    }
  }

  onSubmit(): void {
    if (this.criteriaForm.valid) {

      if (this.fileBase64 && this.originalFileName) {
        this.criteriaForm.patchValue({
          filePath: this.fileBase64,
          originalFileName: this.originalFileName,
        });
      }
      
      this.criteriaService.createAcceptanceCriteria(this.criteriaForm.value).subscribe({
        next: () => {
          this.router.navigate(['/acceptance-criteria']);
        },
        error: error => {
          console.error('Error al crear el criterio de aceptación:', error.message);
          this.errorMessage =
            error.error.message || 'Ocurrió un error al crear el criterio de aceptación';
        },
        complete: () => {
          console.log('Solicitud de creación de criterio de aceptación completada');
        },
      });
    } else {
      this.markAllFieldsAsTouched();
    }
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
      this.originalFileName = this.selectedFile.name;

      const reader = new FileReader();
      reader.readAsDataURL(this.selectedFile);
      reader.onload = () => {
        this.fileBase64 = reader.result as string;
      };
      reader.onerror = error => {
        console.error('Error al leer el archivo:', error);
      };
    }
  }
}
